// columns: array de strings (cabeçalhos)
// rows: array de arrays de strings (ou array de objetos)
export default function ServicesComparisonTable({
  title = 'Os três produtos e o que cada um resolve',
  lead,
  columns = [],
  rows = [],
  headClass = 'bg-[#99020E]',
}) {
  const toCells = row => (Array.isArray(row) ? row : Object.values(row))

  return (
    <div className="w-full px-20 pb-8">
      {title && (
        <h2 className="mb-6 font-inter-extrabold text-2xl text-[#454545]">
          {title}
        </h2>
      )}

      {lead && (
        <p className="mb-6 font-inter-regular text-base leading-relaxed text-[#333333]">
          {lead}
        </p>
      )}

      <div className="overflow-x-auto rounded-[10px] border border-[#D1D5DC]">
        <table className="w-full min-w-[1200px] border-collapse text-left">
          <thead>
            <tr className={headClass}>
              {columns.map((column, index) => (
                <th
                  key={index}
                  className="px-6 py-[26px] font-inter-semibold text-sm text-white"
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {toCells(row).map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className="border-t border-[#D1D5DC] px-6 py-[26px] font-inter-regular text-sm align-top text-[#364153]"
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
